import { SVGProps, Ref, forwardRef } from 'react';

export const HhBusinessAppGrayscaleSize48Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={48}
            height={48}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <rect x={2} y={2} width={44} height={44} rx={11.44} fill="#919191" />
            <path
                d="M35.102 21.335c-.666-.706-1.613-1.091-2.767-1.091-1.436 0-2.538.599-3.173 1.722v-5.572h-3.328v15.273h3.328v-5.37c0-1.25.25-2.053.624-2.523.364-.471.874-.653 1.425-.653.49 0 .874.16 1.144.45.27.299.427.759.427 1.4v6.686h3.329v-7.36c0-1.25-.354-2.267-1.01-2.962"
                fill="#E2E2E2"
            />
            <path
                d="M22.286 21.335c-.666-.706-1.613-1.091-2.767-1.091-1.436 0-2.538.599-3.173 1.722v-5.572h-3.328v15.273h3.328v-5.37c0-1.25.25-2.053.624-2.523.364-.471.874-.653 1.425-.653.49 0 .874.16 1.145.45.27.299.426.759.426 1.4v6.686h3.329v-7.36c0-1.25-.354-2.267-1.01-2.962"
                fill="#E2E2E2"
            />
        </svg>
    )
);
HhBusinessAppGrayscaleSize48Glyph.displayName = 'HhBusinessAppGrayscaleSize48Glyph';
